import React from 'react';
import {Modal} from 'react-bootstrap';
import DotsLoading from '../dotsLoading';
import styles from './dangerModal.module.scss';

type TDangerModalProps = {
  show: boolean;
  setShow: (e: boolean) => void;
  title: string;
  onClick?: () => void;
  children?: React.ReactNode;
  isLoading?: boolean;
};

const DangerModal = ({
  show,
  setShow,
  title,
  onClick,
  children,
  isLoading,
}: TDangerModalProps) => {
  return (
    <>
      <Modal centered show={show} onHide={() => setShow(false)} size="sm">
        <div className={styles['danger-modal']}>
          <div className={styles['danger-modal__icon']}>
            <i className="icon-warning"></i>
          </div>
          <div className="p-3 py-5 mt-4 text-center">
            {' '}
            <b className="color-danger-red">{title}</b>{' '}
          </div>

          {children || (
            <div className="mb-3 d-flex">
              <button
                className="py-3 mx-3 w-100 btn color-danger-red"
                onClick={() => setShow(false)}
              >
                <b className="fw-8">انصراف</b>
              </button>
              <button
                className="py-3 mx-3 border-0 w-100 btn btn-danger bg-color-danger-red color-white"
                onClick={onClick}
                disabled={isLoading}
              >
                {isLoading ? <DotsLoading /> : <>بله</>}
              </button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default DangerModal;
